import { axios } from '@Root/API'

export const getUserStatic = () => {
  return axios.get('get-user-static-options')
}
